import { generatePath, useNavigate } from 'react-router-dom';

import { usePostApiArbitrageAccept } from '@/api/arbitrage/arbitrage';
import { ROUTE } from '@/constants/route';
import { BreadcrumbItem } from '@/services/types/Breadcrumb';
import { isIdentityValidationFailed } from '@/utils/functions/identityValidationError/identityValidationError';

type ValidationResult = {
  success: boolean;
  pieceLu?: boolean;
  pieceMRZ?: boolean;
  infosNonCorrespondante?: boolean;
  pieceExpire?: boolean;
  coordonneesUtilise?: boolean;
  emailUtilise?: string | null;
  telephoneUtilise?: string | null;
  birthdate?: string;
  reasonMessage?: string | null;
};

interface UseArbitrageValidationMutationParams {
  id: string;
  idSouscription: number;
  breadcrumbItems: BreadcrumbItem[];
  storageKey: string;
}

const useArbitrageValidationMutation = ({
  id,
  idSouscription,
  breadcrumbItems,
  storageKey,
}: UseArbitrageValidationMutationParams) => {
  const navigate = useNavigate();
  const acceptMutation = usePostApiArbitrageAccept();

  const mutate = (
    _: number,
    options?: {
      onSuccess?: (data: ValidationResult) => void;
      onError?: (error: unknown) => void;
    }
  ) => {
    acceptMutation.mutate(
      { arbitrageId: id, data: { subscriptionId: idSouscription } },
      {
        onSuccess: (response) => {
          if (isIdentityValidationFailed(response)) {
            options?.onSuccess?.({
              success: false,
              pieceLu: response.pieceLu ?? undefined,
              pieceMRZ: response.pieceMRZ ?? undefined,
              infosNonCorrespondante: response.infosNonCorrespondante ?? undefined,
              pieceExpire: response.pieceExpire ?? undefined,
              coordonneesUtilise: response.coordonneesUtilise ?? undefined,
              emailUtilise: response.emailUtilise,
              telephoneUtilise: response.telephoneUtilise,
              birthdate: response.birthdate ?? undefined,
              reasonMessage: response.reasonMessage,
            });
            return;
          }
          if (!response.url) {
            options?.onError?.(new Error('URL de signature manquante'));
            return;
          }
          sessionStorage.removeItem(storageKey);
          navigate(generatePath(ROUTE.ARBITRAGESIGNATURE, { id }), {
            state: { url: response.url, breadcrumbItems },
          });
        },
        onError: (error) => {
          options?.onError?.(error instanceof Error ? error : new Error("Erreur lors de l'acceptation"));
        },
      }
    );
  };

  return { mutate };
};

export default useArbitrageValidationMutation;
